import { render, staticRenderFns } from "./RefundList.vue?vue&type=template&id=2ecbdc3b&scoped=true&"
import script from "./RefundList.vue?vue&type=script&lang=js&"
export * from "./RefundList.vue?vue&type=script&lang=js&"
import style0 from "./RefundList.vue?vue&type=style&index=0&id=2ecbdc3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecbdc3b",
  null
  
)

export default component.exports